// @ts-ignore
import { Dropdown, DropdownButton } from "../../../vendor";
// @ts-ignore
import Biscuit from "../../utils/Biscuit";
import t from "../helpers/t";
import React, { Fragment } from "react";
// @ts-ignore
import { ADJUSTMENT_HELP_TEXT, HtmlTooltip } from "../../utils/HelperOld";

const DropdownMenu = (props: any) => {
  const {
    menu,
    extra,
    order,
    toggleElement,
    length,
    extra2,
    reservation,
    extra3,
    contingent,
    panels,
    extra4,
    extra5,
    wallet,
    insurance,
    invoice,
    extra8,
    extra9,
    helpMessage,
  } = props;
  let id: string = "i" + props.id;
  if (extra5) {
    id =
      wallet.order_id !== null
        ? "o" + wallet.order_id
        : wallet.accumulated_invoice_id !== null
          ? "a" + wallet.accumulated_invoice_id
          : "i" + props.id;
  }

  // @ts-ignore
  return (
    <>
      <aside>
        <>
          {
            // @ts-ignore
            typeof props.info !== "undefined" && props.info.show && (
              // @ts-ignore
              <HtmlTooltip
                title={
                  <React.Fragment>
                    {
                      <ADJUSTMENT_HELP_TEXT
                        // @ts-ignore
                        content={props.info.info}
                      />
                    }
                  </React.Fragment>
                }
                enterDelay={200}
                leaveDelay={500}
              >
                <label
                  className="inb-form__controlLabel "
                  style={{ position: "absolute", marginTop: "30px", zIndex: 2, maxWidth: "50px" }}
                >
                  <a data-tooltip-id="my-tooltip-data-html">
                    <i className="inb-ico fi fi-info" style={{ fontSize: "1.2rem" }}>
                      {" "}
                    </i>
                  </a>
                  {/* <i className="inb-ico fi fi-info"> </i>*/}
                </label>
              </HtmlTooltip>
            )
          }
          <aside className="inb-c-item__actions">
            {menu.length > 0 && (
              <DropdownButton
                id="dropdown-basic-button"
                title="..."
                drop="down"
                // @ts-ignore
                bsPrefix="button round"
              >
                <ul className="inb-dropdown__list">
                  {menu.map((obj: any, index: string) => {
                    return (
                      <Fragment key={index}>
                        <li data-inb-action-link={obj.title} id={"kln_" + index}>
                          {typeof obj.clickHandler !== "undefined" ? (
                            <Dropdown.Item
                              href={obj.href}
                              onClick={() => obj.clickHandler(obj[obj.getItem])}
                            >
                              <i className={obj.iconClass}> </i>
                              {obj.text}
                            </Dropdown.Item>
                          ) : (
                            <Dropdown.Item href={obj.href}>
                              <i className={obj.iconClass}> </i>
                              {obj.text}
                            </Dropdown.Item>
                          )}
                        </li>
                      </Fragment>
                    );
                  })}
                </ul>
              </DropdownButton>
            )}
            {/* {extra && <button className={"button round inb-toggle-details inb-toggle-details-"+Biscuit.get('user.client_id')} type="button"
                                          title={t('toggle_${a}',{a:t('reservations')}, 'capital') }
                                          data-inb-toggle={"pricetariffs-panel-"+order.id}
                                          onClick={(e) => toggleElement(e,order.id)}
                                          id={"btn_pt_"+order.id}
                        >
                            <i className="fi fi-list-thumbnails"> </i>
                            {length >= 1 &&
                                <div className="badge primary reservations-count">
                                    { length }
                                </div>
                            }
                        </button>} */}
            {extra && (
              <button
                className={
                  "button round inb-toggle-details inb-toggle-details-" +
                  Biscuit.get("user.client_id")
                }
                type="button"
                title={t("toggle_${a}", { a: t("reservations") }, "capital")}
                data-inb-toggle={"pricetariffs-panel-" + order.id}
                onClick={(e) => toggleElement(e, order.id)}
                id={"btn_pt_" + order.id}
              >
                <i className="fi fi-list-thumbnails"> </i>
                {length >= 1 && <div className="badge primary reservations-count">{length}</div>}
              </button>
            )}
            {extra2 && (
              <button
                className={
                  "button round inb-toggle-details inb-toggle-details-" +
                  Biscuit.get("user.client_id")
                }
                type="button"
                title={t("toggle_${a}", { a: t("checkins") }, "capital")}
                data-inb-toggle={"pricetariffs-panel-" + reservation.id}
                onClick={(e) => toggleElement(e, reservation.id)}
                id={"btn_pt_" + reservation.id}
              >
                <i className="fi fi-list-thumbnails"> </i>
                {length >= 1 && <div className="badge primary reservations-count">{length}</div>}
              </button>
            )}
            {/* {extra3 && typeof props.contingent.resourcetype_id !== 'undefined' && props.contingent.resourcetype_id < 4 &&
                                <>
                                <button className="button round inb-toggle-details inb-toggle-details>" type="button" title={t('toggle_${a}',{a:t('contingents')}, 'capital') } data-inb-toggle={'resources-panel-'+props.id}>
                                <i className="fi fi-list-thumbnails"></i>
                                    {typeof props.contingent.resources !== 'undefined' && props.contingent.resources.length >= 1 &&
                                <div className="badge primary reservations-count">
                                    {props.contingent.resources.length}
                                </div>
                                 }
                                </button>
                                </>
                                 }*/}
            {extra3 && (
              <button
                className={"button round inb-toggle-details inb-toggle-details"}
                type="button"
                title={t("toggle_${a}", { a: t("resources") }, "capital")}
                data-inb-toggle={"resources-panel-" + contingent.id}
                onClick={(e) => toggleElement(e, contingent.id)}
                id={"btn_pt_" + contingent.id}
              >
                <i className="fi fi-list-thumbnails"> </i>
                {contingent.resources.length >= 1 && (
                  <div className="badge primary reservations-count">
                    {contingent.resources.length}
                  </div>
                )}
              </button>
            )}
            {extra4 && insurance.insurance_certificates.length >= 1 && (
              <button
                className={"button round inb-toggle-details inb-toggle-details"}
                type="button"
                title={t("toggle_${a}", { a: t("insurance certificates") }, "capital")}
                data-inb-toggle={"insurance_certificates-panel-" + insurance.id}
                onClick={(e) => toggleElement(e, insurance.id)}
                id={"btn_pt_" + insurance.id}
              >
                <i className="fi fi-list-thumbnails"> </i>
                {insurance.insurance_certificates.length >= 1 && (
                  <div className="badge primary reservations-count">
                    {insurance.insurance_certificates.length}
                  </div>
                )}
              </button>
            )}
            {extra5 && wallet.wallet_transactions.length >= 1 && (
              <button
                className={"button round inb-toggle-details inb-toggle-details"}
                type="button"
                title={t("toggle_${a}", { a: t("transactions") }, "capital")}
                data-inb-toggle={"transactions-panel-" + id}
                onClick={(e) => toggleElement(e, id)}
                id={"btn_pt_" + id}
              >
                <i className="fi fi-list-thumbnails"> </i>
                {wallet.wallet_transactions.length >= 1 && (
                  <div className="badge primary reservations-count">
                    {wallet.wallet_transactions.length}
                  </div>
                )}
              </button>
            )}
            {extra8 && invoice.extern_invoices_positions.length >= 1 && (
              <button
                className={"button round inb-toggle-details inb-toggle-details"}
                type="button"
                title={t("toggle_${a}", { a: t("invoice positions") }, "capital")}
                data-inb-toggle={"invoice-items-panel-" + invoice.id}
                onClick={(e) => toggleElement(e, invoice.id)}
                id={"btn_pt_" + invoice.id}
              >
                <i className="fi fi-list-thumbnails"> </i>
                {invoice.extern_invoices_positions.length >= 1 && (
                  <div className="badge primary reservations-count">
                    {invoice.extern_invoices_positions.length}
                  </div>
                )}
              </button>
            )}
            {extra9 && (
              <button
                className={"button round inb-toggle-details inb-toggle-details"}
                type="button"
                title={t("toggle_${a}", { a: t("help message items") }, "capital")}
                data-inb-toggle={"help-message-items-panel-" + helpMessage.id}
                onClick={(e) => toggleElement(e, helpMessage.id)}
                id={"btn_pt_" + helpMessage.id}
              >
                <i className="fi fi-list-thumbnails"> </i>
                {typeof helpMessage.help_message_items !== "undefined" &&
                  helpMessage.help_message_items.length >= 1 && (
                    <div className="badge primary reservations-count">
                      {helpMessage.help_message_items.length}
                    </div>
                  )}
              </button>
            )}
          </aside>
        </>
        {typeof panels !== "undefined" && panels.length > 0 && (
          <button className="button round">
            <i className="fi fi-list-thumbnails"> </i>
          </button>
        )}
      </aside>
    </>
  );
};

export default DropdownMenu;
